import React from "react";

const AdminDocumentViewer = ({ adminDocuments }) => {
  if (!adminDocuments || adminDocuments.length === 0) return null;

  const base = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "http://localhost:3000";

  return (
    <div className="mt-4 p-4 border rounded bg-white shadow-sm">
      <h3 className="font-semibold mb-3">Uploaded Documents</h3>
      <div className="space-y-4">
        {adminDocuments.map((doc, idx) => (
          <div key={idx} className="p-3 bg-gray-50 border rounded flex flex-col gap-2">
            {doc.remark && (
              <p className="text-sm font-medium text-gray-700">
                <span className="font-semibold text-gray-900">Remark:</span> {doc.remark}
              </p>
            )}
            <div>
              <p className="text-xs text-gray-500 mb-1">Files ({doc.files.length}):</p>
              <div className="flex flex-wrap gap-2">
                {doc.files.map((file, fIdx) => {
                  const fileName = file.split("/").pop() || file.split("\\").pop();
                  return (
                    <a
                      key={fIdx}
                      href={`${base}/${file}`}
                      target="_blank"
                      rel="noreferrer"
                      className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded hover:bg-blue-200 truncate max-w-[200px]"
                      title={fileName}
                    >
                      {fileName}
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDocumentViewer;
